'use client'

import { createContext, useContext, useMemo } from 'react'

import type { ReactNode } from 'react'

interface StoryblokImageCacheContextProps {
  lastUpdated?: string
}

const StoryblokImageCacheContext =
  createContext<StoryblokImageCacheContextProps | null>(null)
StoryblokImageCacheContext.displayName = 'StoryblokImageCacheContext'

interface StoryblokImageCacheProviderProps {
  children: ReactNode
  lastUpdated?: string
}

// import { StoryblokImageCacheProvider } from "path-to-context/StoryblokImageCacheContext"
// use <StoryblokImageCacheProvider> as a wrapper around the part you need the context for
function StoryblokImageCacheProvider({
  children,
  lastUpdated,
}: StoryblokImageCacheProviderProps) {
  return (
    <StoryblokImageCacheContext.Provider
      value={useMemo(() => ({ lastUpdated }), [lastUpdated])}
    >
      {children}
    </StoryblokImageCacheContext.Provider>
  )
}

// import { useStoryblokImageCache } fron "path-to-context/StoryblokImageCacheContext"
// within functional component
// const { sessionToken, ...StoryblokImageCacheContext } = useStoryblokImageCache()
function useStoryblokImageCache(): StoryblokImageCacheContextProps {
  const context = useContext(StoryblokImageCacheContext)

  if (!context) {
    return { lastUpdated: undefined }
  }

  return context
}

export { StoryblokImageCacheProvider, useStoryblokImageCache }
